var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.status))]),(_vm.row.status == 'proceeding')?_c('div',[_vm._v("\n    Progress: "+_vm._s(_vm.progress)+" %\n    "),_c('b-button',{staticClass:"border-0 px-2",attrs:{"variant":"outline-primary"},on:{"click":_vm.getExportProgress}},[_c('i',{staticClass:"fa fa-refresh"})])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }